module.exports = __webpack_public_path__ + "img/zeiljachten--dark.a4761eeb.svg";